import React, { Fragment } from 'react';
import { Outlet } from 'react-router-dom';
import TransitionOnLoad from 'Components/TransitionOnLoad';
import PageHeading from 'Layout/AppMain/PageHeading';
import { AfasProvider } from './context/AfasContext';

const Afas = () => {
    return (
        <Fragment>
            <PageHeading />
            <TransitionOnLoad>
                <AfasProvider>
                    <div className="afas-page">
                        <Outlet />
                    </div>
                </AfasProvider>
            </TransitionOnLoad>
        </Fragment>
    );
};

export default Afas;

